export default {
  langauge: undefined,
  messages: undefined,
  availableLocales: undefined,
  missingTranslations: new Set(),
  missingTranslationsTimeout: undefined
};
